/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
 */
export interface AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto {
    /**
     * 승인 상태
     * @type {string}
     * @memberof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
     */
    'approvalStatus'?: AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoApprovalStatusEnum;
    /**
     * 성별
     * @type {string}
     * @memberof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
     */
    'gender'?: AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoGenderEnum;
    /**
     * 나이
     * @type {number}
     * @memberof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
     */
    'age'?: number;
    /**
     * 관리자 체크 여부
     * @type {boolean}
     * @memberof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
     */
    'isCheck'?: boolean;
}

export const AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoApprovalStatusEnum = {
    Pending: 'pending',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoApprovalStatusEnum = typeof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoApprovalStatusEnum[keyof typeof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoApprovalStatusEnum];
export const AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoGenderEnum = typeof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoGenderEnum[keyof typeof AdminPatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDtoGenderEnum];


